import { TripAccessCode } from "../enums/TripAccessCode";
import { TripStatusCode } from "../enums/TripStatusCode";
import { getTripDuration } from "./functions";
import tripPrivacyDetails from "../../components/common/trip-privacy/TripPrivacyDetails";
export var FIRST_RIDER_MESSAGE = "Be Among The First Riders";
export var getParticipantsSubtext = function (joined) {
    return joined > 0 ? "".concat(joined, " joined") : FIRST_RIDER_MESSAGE;
};
export var getSpotsFilledLabel = function (joined, maxParticipants) {
    return joined > 0
        ? "".concat(joined, " of ").concat(maxParticipants, " spots filled")
        : FIRST_RIDER_MESSAGE;
};
export var getParticipantStats = function (trip) {
    var _a, _b, _c;
    var joined = (_c = (_a = trip.currentParticipantCount) !== null && _a !== void 0 ? _a : (_b = trip.participants) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
    var hasMax = typeof trip.maxParticipants === "number" && !Number.isNaN(trip.maxParticipants);
    var spotsLeft = hasMax ? Math.max(trip.maxParticipants - joined, 0) : null;
    var fillPercent = hasMax && trip.maxParticipants > 0
        ? Math.min((joined / trip.maxParticipants) * 100, 100)
        : 0;
    return { joined: joined, spotsLeft: spotsLeft, fillPercent: fillPercent, hasMax: hasMax };
};
export var formatTripStatusLabel = function (status) {
    switch (status) {
        case TripStatusCode.YET_TO_START:
            return "Yet to Start";
        case TripStatusCode.IN_PROGRESS:
            return "In Progress";
        case TripStatusCode.COMPLETED:
            return "Completed";
        case TripStatusCode.CANCELLED:
            return "Cancelled";
        default:
            return String(status).replace(/_/g, " ");
    }
};
export var getPrivacySummary = function (privacy) {
    var config = tripPrivacyDetails[privacy] || tripPrivacyDetails[TripAccessCode.PUBLIC];
    var approvalRequired = privacy === TripAccessCode.APPROVAL;
    return {
        label: config.label.replace(/\.$/, ""),
        subText: config.subText,
        approvalRequired: approvalRequired,
    };
};
export var getTripStats = function (trip) {
    var _a = getTripDuration(trip.startDate, trip.endDate), duration = _a.duration, dateRangeDisplay = _a.dateRangeDisplay;
    var _b = getParticipantStats(trip), joined = _b.joined, spotsLeft = _b.spotsLeft;
    var privacy = getPrivacySummary(trip.privacySetting);
    return {
        duration: duration,
        dateRangeDisplay: dateRangeDisplay,
        joined: joined,
        spotsLeft: spotsLeft,
        privacy: privacy,
    };
};
